import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Plot from 'react-plotly.js';
import { ManRadioButtonGroup, ManRadioButton, ManText, ManCard } from '@craft-design-system/core-components-react';
import ifav from '../ifav.png';
import { Button, Popover, OverlayTrigger } from 'react-bootstrap';
import Zoom from '../../Zoom';

const CommonKPI = ({ value, kpiTitle, KpiDescription , KPIheight}) => {
  const [kpiData, setKpiData] = useState(null);
  const [isAverageValue, setIsAverageValue] = useState(false);

  const popover = (
    <Popover id="popover-basic">
    <Popover.Body>
        {KpiDescription ? (
        <span dangerouslySetInnerHTML={{ __html: KpiDescription }} />
         ) : (
        <>Default description here</>
    )}
    </Popover.Body>
    </Popover>
  );

  useEffect(() => {
    try {
      const parsedData = JSON.parse(value);
      
      if (parsedData.single_vin && parsedData.average_value) {
        setIsAverageValue(true);
        setKpiData(parsedData);
      } else {
        setIsAverageValue(false);
        setKpiData(parsedData);
      }
    } catch (error) {
      console.error("Error parsing JSON", error);
      setKpiData(null);
      setIsAverageValue(false);
    }
  }, [value]);

  return (
    <ManCard className='card_battery' appearance="soft" outline="false">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px',
        gap: '8px'
      }}>
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <ManText className="card-title-text" variant="component-l" as="span" size="l"
          style={{}}>
          {kpiTitle}
        </ManText>
      </div>
      <div style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row-reverse',
        justifyContent: 'end',
      }}>
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
          <img className="man-logovv1" src={ifav} />
        </OverlayTrigger>
        {!isAverageValue && (
          <Zoom
            chartData={kpiData?.data}
            chartLayout={kpiData?.layout}
            chartTitle={kpiTitle}
          />
        )}
      </div>
      </div>
      
      {kpiData ? (
        isAverageValue ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: KPIheight,
            textAlign: 'center',
            gap: '16px'
          }}>
            <ManText 
              variant="display-s" 
              as="div" 
              style={{ 
                fontSize: '22px',
                fontWeight: 'bold',
                color: '#59636D',
                lineHeight: '1.2'
              }}
            >
              {kpiData.average_value === "NA" ? "NA" : parseFloat(kpiData.average_value).toFixed(4)}
            </ManText>
          </div>
        ) : (

          <Plot 
            data={kpiData.data} 
            layout={{
              ...kpiData.layout,
              autosize: true,
              responsive: true,
              margin: { t: 10, r: 10, l: 10, b: 10 } 
            }}
            style={{ width: '100%', height: KPIheight }}
            useResizeHandler={true} 
          />
        )
      ) : (
        <ManText className="title" variant="body-l" as="span">
          KPI will be available soon
        </ManText>
      )}
    </ManCard>
  );
};

CommonKPI.propTypes = {
  value: PropTypes.string.isRequired,
  kpiTitle: PropTypes.string,
  KpiDescription: PropTypes.string,
  KPIheight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CommonKPI;